import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import {
    INSTITUTION_KEYS,
    institutionLabel,
} from '@/shared/constants/institutions';
import {
    BUILDING_MAX_LENGTH,
    CATEGORY_LABELS,
} from '@/shared/constants/listings';

// Building is a partial match on a campus everyone navigates by building
// name, so the box holds part of one rather than asking for the whole.
function ListingFilters({ value, onChange, onSubmit }) {
    const set = (key) => (event) =>
        onChange({ ...value, [key]: event.target.value });

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit();
    };

    return (
        <Form onSubmit={handleSubmit} className="mb-4">
            <Row className="g-2 align-items-end">
                <Col md={2}>
                    <Form.Group controlId="filter-institution">
                        <Form.Label>Institution</Form.Label>
                        <Form.Select
                            value={value.institution}
                            onChange={set('institution')}
                        >
                            <option value="">All institutions</option>
                            {INSTITUTION_KEYS.map((key) => (
                                <option key={key} value={key}>
                                    {institutionLabel(key)}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group controlId="filter-category">
                        <Form.Label>Category</Form.Label>
                        <Form.Select
                            value={value.category}
                            onChange={set('category')}
                        >
                            <option value="">All categories</option>
                            {Object.entries(CATEGORY_LABELS).map(
                                ([key, label]) => (
                                    <option key={key} value={key}>
                                        {label}
                                    </option>
                                )
                            )}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group controlId="filter-building">
                        <Form.Label>Building</Form.Label>
                        <Form.Control
                            type="search"
                            maxLength={BUILDING_MAX_LENGTH}
                            value={value.building}
                            onChange={set('building')}
                            placeholder="Tivoli"
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group controlId="filter-q">
                        <Form.Label>Search</Form.Label>
                        <Form.Control
                            type="search"
                            value={value.q}
                            onChange={set('q')}
                            placeholder="Oak desk"
                        />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Button type="submit" className="w-100">
                        Search
                    </Button>
                </Col>
            </Row>
        </Form>
    );
}

ListingFilters.propTypes = {
    value: PropTypes.shape({
        institution: PropTypes.string,
        category: PropTypes.string,
        building: PropTypes.string,
        q: PropTypes.string,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default ListingFilters;
